import { FieldPath, useWatch } from '@guiker/react-framework'
import { NEWProperty } from '@guiker/real-estate-shared'

type WithProperty = { property: NEWProperty }

export const useWatchProperty = <TFieldName extends FieldPath<WithProperty>>(args?: { name: TFieldName }) => {
  return useWatch<WithProperty, TFieldName>(args)
}
